import React, { Component } from 'react';
import { Provider } from 'react-redux';

import store from './store';  //状态管理
import RouterComponent from "./router";

import LoadingAuto from './components/loading-auto';
import $config from '@/config';

export default class App extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props){
        super(props);
    }

    render() {
        this.systemUpdataing()
        return (
            <React.Fragment>
                <Provider store={store}>
                    <RouterComponent />
                    {/* 加载状态 */}
                    <LoadingAuto />
                </Provider>
            </React.Fragment>
        )
    }

    systemUpdataing(){
        const frameDiv = document.createElement("script")
        frameDiv.setAttribute("src",$config.maintainUrl+'?z='+new Date().getTime())
        const container=document.body;
        container.appendChild(frameDiv)
        frameDiv.onload=function(){
            //判断是否维护中
            if(window.maintainConfig&&window.maintainConfig.iotManagement){
                location.href = '#/maintain'
            }
        }
    }

}

